import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = {
  default: ({ isExclusiveCollection }) => ({
    thRoot: 'text-center',
    thIcon: classnames(
      'mb-15',
      { 'rounded-full bg-lightSand p-15 text-black': !isExclusiveCollection },
      { 'rounded-12 border-5 border-ultramarine p-10 text-ultramarine': isExclusiveCollection },
    ),
    thIconWidth: '6.25rem',
    thIsNotSquare: false,
    thProductInfo: 'flex flex-col-reverse text-initial',
    thProductCountry: 'font-bold text-14 text-sienna truncate w-full',
    thProductName: 'font-bold leading-tight text-18',
  }),
  calendar: () => ({
    thRoot: 'font-brand leading-tight text-black text-center text-16',
    thIconWidth: '5rem',
    thIsNotSquare: true,
  }),
};
